import { create } from "zustand";

const PlanStore = create((set) => ({
  selectedPlan: null,

  setSelectedPlan: (p) =>
    set({ selectedPlan: p }),

  clearSelectedPlan: () =>
    set({ selectedPlan: null }),
}));

export default PlanStore;